export default {
    action: 'create',
    loaded_poster: undefined,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/state.js